var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_ADD_PERMISSION
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamAddPermission($id: ID!, $permission: TEAM_PERMISSION!) {\n    teamAddPermission(id: $id, permission: $permission) {\n      id\n      permissions\n    }\n  }\n"], ["\n  mutation TeamAddPermission($id: ID!, $permission: TEAM_PERMISSION!) {\n    teamAddPermission(id: $id, permission: $permission) {\n      id\n      permissions\n    }\n  }\n"])));
export default function useTeamAddPermission(message) {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamAddPermission',
        successMessage: message || ''
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
